/**
 * Customers page
 *
 * Standalone page for the customer directory (search & details). This is the
 * Customers tab lifted out of the old combined User Management page into its
 * own CUSTOMERS nav section.
 */
import { Box, Typography } from '@mui/material';
import { PersonSearch as CustomerIcon } from '@mui/icons-material';
import { CustomersTab } from '../components/UserManagement/CustomersTab';
import { useAdminTheme } from '../admin-theme';

const Customers = () => {
  const { colors, glassHeaderStyle } = useAdminTheme();

  return (
    <Box sx={{ bgcolor: colors.bgDeepest, minHeight: '100vh' }}>
      <Box sx={{ ...glassHeaderStyle, px: 3, py: 2.5 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: colors.textPrimary,
            letterSpacing: '-0.02em',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <CustomerIcon sx={{ fontSize: 32 }} />
          Customers
        </Typography>
        <Typography variant="body2" sx={{ color: colors.textSecondary, mt: 0.5 }}>
          Search customers and view their details
        </Typography>
      </Box>

      <Box sx={{ p: 3 }}>
        <CustomersTab />
      </Box>
    </Box>
  );
};

export default Customers;
